import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckChequesRechazados = ({ chequesRechazadosCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = chequesRechazadosCheck?.checkDetails?.results
  const hasChecks = details?.causales?.length > 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:chequesRechazados')}</Typography>
        <CheckRiskStatus checkLength={hasChecks ? 1 : 0} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={chequesRechazadosCheck?.email}
        status={chequesRechazadosCheck?.status}
        createdAt={chequesRechazadosCheck?.createdAt}
        updatedAt={chequesRechazadosCheck?.updatedAt}
      />

      {details && (
        <>
          <div className="c-detail-row">
            <Typography variant="subtitle1">Identificación</Typography>
            <Typography variant="subtitle3">{details.identificacion || '---'}</Typography>
          </div>
          <div className="c-detail-row">
            <Typography variant="subtitle1">Denominación</Typography>
            <Typography variant="subtitle3">{details.denominacion || '---'}</Typography>
          </div>
        </>
      )}

      {hasChecks ? (
        <>
          <Typography variant="subtitle2" sx={{ mt: 4, mb: 2 }}>
            Causales
          </Typography>

          {details.causales.map((causal, index) => (
            <Paper key={index} elevation={0} variant="rootOutlined">
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Causal</Typography>
                  <Typography variant="subtitle3">{causal.causal || '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">Entidad</Typography>
                  <Typography variant="subtitle3">
                    {causal.entidades?.map((entidad) => entidad.entidad || '---').join(', ')}
                  </Typography>
                </div>
              </div>
              {causal.entidades?.map((entidad, _) =>
                entidad.detalle.map((detalle, idx) => (
                  <TimelineDotLine key={index}>
                    <div key={idx} className="c-detail-grid">
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Número cheque</Typography>
                        <Typography variant="subtitle3">{detalle.nroCheque ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Fecha rechazo</Typography>
                        <Typography variant="subtitle3">{detalle.fechaRechazo ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Monto</Typography>
                        <Typography variant="subtitle3">{detalle.monto ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Fecha pago</Typography>
                        <Typography variant="subtitle3">{detalle.fechaPago ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Fecha pago multa</Typography>
                        <Typography variant="subtitle3">{detalle.fechaPagoMulta ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Estado multa</Typography>
                        <Typography variant="subtitle3">{detalle.estadoMulta ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Cuenta personal</Typography>
                        <Typography variant="subtitle3">{detalle.ctaPersonal ? 'Sí' : '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Denominación jurídica</Typography>
                        <Typography variant="subtitle3">{detalle.denomJuridica ?? '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">En revisión</Typography>
                        <Typography variant="subtitle3">{detalle.enRevision ? 'Sí' : 'No'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Proceso judicial</Typography>
                        <Typography variant="subtitle3">{detalle.procesoJud ? 'Sí' : 'No'}</Typography>
                      </div>
                    </div>
                  </TimelineDotLine>
                )),
              )}
            </Paper>
          ))}
        </>
      ) : (
        <Typography variant="body2" sx={{ mt: 2 }}>
          {chequesRechazadosCheck?.checkDetails?.info || '---'}
        </Typography>
      )}
    </>
  )
}

export default CheckChequesRechazados

/* import { Box, Typography, Card, CardContent, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckChequesRechazados = ({ title = '', chequesRechazadosCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = chequesRechazadosCheck?.checkDetails?.results

  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>
        {title || t('common:chequesRechazados')}
      </Typography>

      <CheckDetailTitle
        email={chequesRechazadosCheck?.email}
        status={chequesRechazadosCheck?.status}
        createdAt={chequesRechazadosCheck?.createdAt}
        updatedAt={chequesRechazadosCheck?.updatedAt}
      />

      {details && (
        <Box mt={2}>
          <Typography variant="body1">
            <strong>Identificación:</strong> {details.identificacion || '---'}
          </Typography>
          <Typography variant="body1">
            <strong>Denominación:</strong> {details.denominacion || '---'}
          </Typography>
        </Box>
      )}

      {details?.causales?.length > 0 ? (
        <Box mt={2}>
          <Typography variant="h4">Causales</Typography>
          {details.causales.map((causal, index) => (
            <Card key={index} variant="outlined">
              <CardContent>
                <Typography variant="body1">
                  <strong>Causal:</strong> {causal.causal || '---'}
                </Typography>
                <Typography variant="body1">
                  <strong>Entidad:</strong> {causal.entidades?.map((entidad) => entidad.entidad || '---').join(', ')}
                </Typography>
                <Divider sx={{ my: 2 }} />

                {causal.entidades?.map((entidad, _) =>
                  entidad.detalle.map((detalle, indexDetalle) => (
                    <Box key={indexDetalle}>
                      <Typography>
                        <strong>Número cheque:</strong> {detalle.nroCheque ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Fecha rechazo:</strong> {detalle.fechaRechazo ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Monto:</strong> {detalle.monto ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Fecha pago:</strong> {detalle.fechaPago ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Fecha pago multa:</strong> {detalle.fechaPagoMulta ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Estado multa:</strong> {detalle.estadoMulta ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>Cuenta personal:</strong> {detalle.ctaPersonal ? 'SI' : '---'}
                      </Typography>
                      <Typography>
                        <strong>Denominación jurídica:</strong> {detalle.denomJuridica ?? '---'}
                      </Typography>
                      <Typography>
                        <strong>En revisión:</strong> {detalle.enRevision ? 'Sí' : 'No'}
                      </Typography>
                      <Typography>
                        <strong>Proceso judicial:</strong> {detalle.procesoJud ? 'Sí' : 'No'}
                      </Typography>
                    </Box>
                  )),
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        <Typography variant="body1">{chequesRechazadosCheck?.checkDetails?.info}</Typography>
      )}
    </Box>
  )
}

export default CheckChequesRechazados
 */
